// components/LazyLoader.tsx
import { Suspense, ReactNode } from "react";
import Spinner from "../ui/Spinner";

const LazyLoader = ({ children }: { children: ReactNode }) => {
  return <Suspense fallback={<Spinner />}>{children}</Suspense>;
};

export default LazyLoader;
